import MyTable, { MyTableBody, MyTableCol, MyTableHeader, MyTableRow, MyTableWrapper } from 'components/MyTable';
import Spin from 'components/Spin';
import { WithStyles } from 'decorators/withStyles';
import React, { PureComponent } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';

import type { ICDFItems } from 'store/Orbita/FiscalDocuments/interfaces';

interface IPropsFromConnect {
  isFetching: boolean;
  items: ICDFItems;

  classes?: any;
}

@WithStyles({
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
})
class Items extends PureComponent<IPropsFromConnect> {
  headers = [{ title: 'Detalhes' }, { title: 'Qtd' }, { title: 'Total', numeric: true }];

  render() {
    const { isFetching, items, classes } = this.props;

    if (isFetching) {
      return <Spin />;
    }

    return (
      <MyTableWrapper minWidth={345}>
        <MyTable>
          <MyTableHeader index={this.headers} />
          <MyTableBody>
            {!items.length && (
              <tr>
                <td colSpan={this.headers.length} className={classes.emptyMessage}>
                  Nenhum registro encontrado.
                </td>
              </tr>
            )}
            {items.map((item: any) => (
              <MyTableRow className={classes.tr} key={item.id}>
                <MyTableCol>{item.description}</MyTableCol>
                <MyTableCol>{item.qty}</MyTableCol>
                <MyTableCol numeric>
                  <FormattedNumber value={item.value || 0} format='BRL' />
                </MyTableCol>
              </MyTableRow>
            ))}
          </MyTableBody>
        </MyTable>
      </MyTableWrapper>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    isFetching: state.orbita.FiscalDocuments.details.isItemsFetching,
    items: state.orbita.FiscalDocuments.details.items || [],
  };
}

export default connect<IPropsFromConnect, {}, {}>(mapStateToProps)(Items);
